export enum ColumnTypeEnumeration {
  TEXT_COLUMN = 'TEXT_COLUMN',
  DATE_COLUMN = 'DATE_COLUMN',
  ACTION_COLUMN = 'ACTION_COLUMN',
  SELECT_COLUMN = 'SELECT_COLUMN',
  CHECKBOX_COLUMN = 'CHECKBOX_COLUMN',
  NUMBER_COLUMN = 'NUMBER_COLUMN'
}
